/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApplyPenaltyCommand } from '../../models/apply-penalty-command';
import { ApplyPenaltyCommandResult } from '../../models/apply-penalty-command-result';

export interface ApiKpiReportsApplyPenaltyPost$Plain$Params {
      body?: ApplyPenaltyCommand
}

export function apiKpiReportsApplyPenaltyPost$Plain(http: HttpClient, rootUrl: string, params?: ApiKpiReportsApplyPenaltyPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ApplyPenaltyCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiKpiReportsApplyPenaltyPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApplyPenaltyCommandResult>;
    })
  );
}

apiKpiReportsApplyPenaltyPost$Plain.PATH = '/api/KPIReports/ApplyPenalty';
